/**
 * @generated SignedSource<<494e0157a54b17156f899b3907e96f4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomPropertySelect_data$data = {
  readonly roomProperties: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly etgKey: string | null;
        readonly icon: string | null;
        readonly id: string;
        readonly name: string | null;
      };
    }>;
  };
  readonly " $fragmentType": "RoomPropertySelect_data";
};
export type RoomPropertySelect_data$key = {
  readonly " $data"?: RoomPropertySelect_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomPropertySelect_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomPropertySelect_data",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2147483647
        }
      ],
      "concreteType": "RoomPropertyConnection",
      "kind": "LinkedField",
      "name": "roomProperties",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoomPropertyEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoomProperty",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "icon",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "etgKey",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "roomProperties(first:2147483647)"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "cdc9d817117153181123a9ab5b705f97";

export default node;
